module.exports = __webpack_public_path__ + "img/patients-info-bkg.png";